import React, { useEffect, useState } from 'react';
import me from "../assests/m3_3.JPG";
import education from "../assests/education.gif";
import experience from "../assests/experience2.gif";
import career from "../assests/rocket.gif";
import hobbie from "../assests/hobbie.gif";
import contactMe from "../assests/contactMe.gif";
import undergrad from "../assests/cap.png";
import grad from "../assests/graduated.png";
import mbLogo from "../assests/mbLogo.png";
import qualcommLogo from "../assests/Qualcomm-Emblem.png";
import Skills from "./skills";
import Projects from "./projects";
import Footer from "./footer";
import Education from './education';
import Hobbies from './hobbies';

const NavIcon = ({ href, src, alt, className }) => (
    <a className={`circle ${className}`} href={href}>
        <img src={src} alt={alt} loading="lazy" />
    </a>
);

export default function Nav() {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const listenToScroll = () => {
            const heightToHideFrom = 1100;
            const winScroll = document.documentElement.scrollTop;
            setIsVisible(winScroll <= heightToHideFrom);
        };

        window.addEventListener("scroll", listenToScroll);
        return () => window.removeEventListener("scroll", listenToScroll);
    }, []);

    return (
        <>
            <div className="aboutMe-container" id="third">
                {[
                    { href: "#skills", src: experience, alt: "Experience", className: "deg-0" },
                    // { href: "#skills", src: career, alt: "Career", className: "deg-45" },
                    { href: "#ed", src: education, alt: "Education", className: "deg-45" },
                    { href: "#hobbies", src: hobbie, alt: "Hobbies", className: "deg-135" },
                    { href: "#contact", src: contactMe, alt: "Contact", className: "deg-180" }
                ].map((icon, idx) => (
                    <NavIcon key={idx} {...icon} />
                ))}
                <div className="aboutMe-image">
                    <img src={me} alt="Profile" loading="lazy" />
                </div>
            </div>

            <div className="main">
                
                <section id="skills" className="section-skills">
                    <div className="section-header">Experience</div>
                    <div className="section-experience">
                        <div className="exp-logo">
                            <img src={qualcommLogo} alt="Qualcomm Logo" loading="lazy" />
                        </div>
                        <div className="exp-detail">
                        At Qualcomm, I spearheaded the development and deployment of a workflow optimization tool
                            for the CPU team, achieving a 35% improvement in task management efficiency. I automated
                            large-scale data structuring using Python scripts integrated with Jenkins cron jobs,
                            significantly streamlining processes. Additionally, I designed an advanced rule engine
                            with regular expressions and Redis caching to enhance data retrieval speed by 40%. My
                            contributions also included optimizing deployment pipelines using Terraform, Kubernetes,
                            and GitLab, reducing manual interventions by 50% while boosting scalability and
                            minimizing downtime.
                        </div>
                    </div>
                    <div className="section-experience second-exp">
                        <div className="exp-detail">
                        At Mercedes-Benz Research & Development, I developed an application to simplify component
                            data management and streamline certification workflows, reducing processing time by 60%.
                            I designed a custom data migration pipeline using Objection.js and Knex, automating
                            environment data flow and ensuring integrity while cutting transfer times by 50%. My
                            focus on scalable storage with Amazon S3 and rapid retrieval through Elasticsearch
                            enhanced system responsiveness by 65%. This experience significantly expanded my
                            expertise in data optimization, scalable architectures, and system performance
                            enhancement, equipping me with a well-rounded understanding of complex enterprise
                            systems.                        
                        </div>
                        <div className="exp-logo-2">
                            <img src={mbLogo} alt="Mercedes-Benz Logo" loading="lazy" />
                        </div>
                    </div>
                </section>
                <section>
                    <div className="section-header">Education</div>
                        <Education/>
                </section>

                <section>
                    <div className="section-header">Skills</div>
                    <Skills />
                </section>

                <section id="projects" className="sec-projects">
                    <div className="section-header">Projects</div>
                    <Projects />
                </section>
                
                <section>
                    <div className="section-header">Hobbies</div>
                        <Hobbies/>
                </section>

                
            </div>

            <div id="contact">
                <Footer />
            </div>

            <div className="showNav">
    <div className={`aboutMeNav-container ${isVisible ? "hidden" : "show"}`}>
        {[
            { href: "#skills", text: "Experience" },
            { href: "#skills", text: "Career" },
            { href: "#ed", text: "Education" },
            { href: "#hobbies", text: "Hobbies" },
            { href: "#contact", text: "Contact" }
        ].map((section, idx) => (
            <a key={idx} href={section.href} className="nav-text">
                {section.text}
            </a>
        ))}
    </div>
</div>

        </>
    );
}
